import { DropDown } from "../Common/dropDown";
import { DatePickerInput } from "../Common/datePicker";
import TrashIcon from "../../assets/trash-outline.svg";
import { CurrencyInputField } from "../Common/currencyInput";
import { IncomeTypeMapping } from "../../interfaces/mortgageDetailsInterface";

interface OtherIncomeBoxProps {
  onRemove: () => void;
  annualAmount: string;
  approximateStartDate: Date | null;
  incomeType: string;

  annualAmountError?: string;
  approximateStartDateError?: string;
  incomeTypeError?: string;

  setAnnualAmount: (value: string) => void;
  setApproximateStartDate: (date: Date | null) => void;
  setIncomeType: (value: string) => void;
}

const OtherIncomeBox = ({
  onRemove,
  annualAmount,
  annualAmountError,
  approximateStartDate,
  approximateStartDateError,
  incomeType,
  incomeTypeError,
  setAnnualAmount,
  setIncomeType,
  setApproximateStartDate,
}: OtherIncomeBoxProps) => {
  const incomeTypeOptions = Object.keys(IncomeTypeMapping);

  return (
    <div className="rounded-[8px] border-[#E5E7EB] border-2">
      <div className="font-medium flex items-center justify-between w-full bg-[#E5E7EB]/50 rounded-t-[8px] border-b-[#E5E7EB] border-b-2 px-3 py-4">
        <div>Other Income</div>
        <button
          type="button"
          className="flex items-center gap-1 text-[#EF4444] text-xs font-medium"
          onClick={onRemove}
        >
          Delete <img src={TrashIcon} alt="Delete icon" />
        </button>
      </div>
      <div className="p-4 space-y-6">
        <div className="space-y-2">
          <div className="text-z-dark-moss-green font-medium">
            Property Details
          </div>
          <div className="grid lg:grid-cols-2 gap-4">
            <div className="w-full space-y-1">
              <DropDown
                label="Income Type*"
                options={incomeTypeOptions}
                selectedOption={
                  Object.keys(IncomeTypeMapping).find(
                    (key) => IncomeTypeMapping[key] === incomeType
                  ) || ""
                }
                onSelect={(value) => setIncomeType(IncomeTypeMapping[value])}
              />
              {incomeTypeError && (
                <p className="text-red-600 text-sm">{incomeTypeError}</p>
              )}
            </div>
            <div className="w-full space-y-1">
              <CurrencyInputField
                id="annualAmount"
                label="Annual Amount ($)*"
                placeholder="Enter annual amount"
                value={annualAmount}
                onChange={setAnnualAmount}
              />
              {annualAmountError && (
                <p className="text-red-600 text-sm">{annualAmountError}</p>
              )}
            </div>
            <div className="w-full space-y-1">
              <DatePickerInput
                label="Approximate Start Date*"
                selectedDate={approximateStartDate}
                onDateChange={setApproximateStartDate}
              />
              {approximateStartDateError && (
                <p className="text-red-600 text-sm">
                  {approximateStartDateError}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { OtherIncomeBox };
